/**
 * The brand taxonomy pill for industry tags (clients-list brief token map).
 * Uniform indigo recipe: industries are taxonomy, not status, so there is
 * deliberately no per-industry colorizer and no copper. Shared by the list's
 * name cell and the detail header; IndustryMultiCombobox's removable chip
 * carries the same recipe with its own interactive anatomy.
 */
export function IndustryChip({ name }: { name: string }) {
    return (
        <span className="bg-primary/10 text-primary rounded-sm px-1.5 text-xs font-medium whitespace-nowrap">
            {name}
        </span>
    );
}
